import { inject, Injectable } from '@angular/core';
import { UseCaseGet } from '@shared/helper';
import { GetCategoryHaloPackageResp } from './get-category-halo-package.type';
import { Observable } from 'rxjs';
import { PackageRepository } from '@data/repositories/package.repository';

@Injectable({
    providedIn: 'root'
})

export class GetCategoryHaloPackageUsecase implements UseCaseGet<GetCategoryHaloPackageResp> {
    private readonly packageRepository = inject(PackageRepository);

    execute(): Observable<GetCategoryHaloPackageResp> {
        return this.packageRepository.GetCategoryHaloPackage();
    }
}